import { useCallback, useState } from 'react'
import { useDropzone } from 'react-dropzone'

function DropZone(props: any) {
    const [files, setFiles]: any = useState([]);
    const onDelete = (e: any) => {
        const filteredList = files.filter((i: any) => i.name !== e.name);
        setFiles(filteredList);
    }

    const onDrop = useCallback((acceptedFiles: any) => {
        // Do something with the files
        props.onUploadComplete(acceptedFiles);
        setFiles([...files, ...acceptedFiles]);
    }, [])

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

    return (
        <>
            <div {...getRootProps()} style={{ border: 'dashed 2px gray', padding: '16px', textAlign: 'center' }}>
                <input {...getInputProps()} />
                {
                    isDragActive ?
                        <div>Drop the files here ...</div> :
                        <div>Drag 'n' drop some files here, or click to select files</div>
                }

            </div>
            <div className="mt-3">
                {
                    files.map((item: any, index: number) => {
                        return (
                            <div key={index} className="row">
                                <div className="col">
                                    {index + 1}. {item.name}
                                </div>
                                <div className="col-auto">
                                    &nbsp;{(item.size / 1024).toFixed(2)} KB
                                    <button className="btn btn-link text-danger p-0 ml-3" type="button" onClick={() => onDelete(item)}>Delete</button>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </>
    )
}

export default DropZone;